'use es6';

export function getExtraJsonForAction(actionEvent, extraJson = {}) {
  return Object.assign({
    action: actionEvent
  }, extraJson);
}